var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c(
        "div",
        {
          staticClass:
            "h-11 px-3 flex items-center justify-between gap-4 rounded hover:bg-hover-state cursor-pointer",
          class: { "bg-slate-300": _vm.isActive },
          on: {
            click: function($event) {
              return _vm.$emit("change-select", _vm.room.id)
            }
          }
        },
        [
          _c("div", { staticClass: "flex truncate" }, [
            _c(
              "div",
              {
                staticClass: "min-w-12 flex truncate",
                attrs: { title: _vm.room.name }
              },
              [
                _c("BlTextSubtitle3", {
                  staticClass: "truncate",
                  attrs: { text: _vm.room.name }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.isActive
            ? _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _vm.enableBranch && _vm.room.branch_id
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "h-7 min-w-12 max-w-32 px-2 flex items-center justify-center rounded truncate",
                          style: {
                            backgroundColor:
                              _vm.room.branch.background_color || "unset"
                          },
                          attrs: { title: _vm.room.branch.name || "-" }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            style: { color: _vm.room.branch.color || "unset" },
                            attrs: { text: _vm.room.branch.name || "-" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentUser.role.includes("admin")
                    ? _c("BlInputButton", {
                        staticClass:
                          "hover:bg-hover-state w-6 h-6 flex items-center justify-center mr-2",
                        attrs: {
                          icon: "edit",
                          type: "plain",
                          title: "Edit room"
                        },
                        on: {
                          clicked: function($event) {
                            _vm.editOpened = true
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.editOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Edit room",
                label: "Update",
                disabled: _vm.isDisabledSubmit
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.editOpened = false
                },
                "backdrop-action": _vm.onUpdate
              }
            },
            [
              _c(
                "div",
                { staticClass: "relative px-8 flex flex-col gap-4" },
                [
                  _c("BlInputText", {
                    attrs: { input: _vm.nameInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _vm.enableBranch
                    ? _c("BlSelectBox", {
                        attrs: {
                          type: "branch",
                          label: "Branch",
                          placeholder: "Select branch",
                          options: _vm.branchOptions,
                          search: ""
                        },
                        on: {
                          change: function($event) {
                            _vm.branchInput = $event
                          }
                        },
                        model: {
                          value: _vm.branchInput,
                          callback: function($$v) {
                            _vm.branchInput = $$v
                          },
                          expression: "branchInput"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "absolute left-8 -bottom-14 z-10" },
                    [
                      _c(
                        "BlTooltip",
                        { attrs: { tooltip: "" } },
                        [
                          _c("BlInputButton", {
                            attrs: {
                              type: "plain-error",
                              icon: "trash",
                              label: "Delete Room",
                              disabled: false
                            },
                            on: {
                              clicked: function($event) {
                                _vm.deleteOpened = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete the room",
                label: "Delete",
                type: "error",
                disabled: _vm.deleteLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onRemove
              }
            },
            [
              _c("div", { staticClass: "px-8" }, [
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "You are about to delete the" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "font-bold",
                      attrs: { text: "" + _vm.room.name }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "from the clinic. Are you sure you want to proceed?"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "This action is irreversible." }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14c9efbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c9efbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/room/Item.vue
// module id = null
// module chunks = 